var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm mr-1",class:{ 'filter-checkbox': true, active: _vm.checked },attrs:{"type":"button "},on:{"click":_vm.checkFilter}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a15086","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artworks/FilterCheckbox.vue
// module id = 5yCE
// module chunks = 1